import { lazyWithStyles } from "../../utils/lazyWithStyles";
import React from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import { resolveQuickBookPlacement } from "./quickBookPlacement";

const QUICK_BOOK_V1_ENABLED = process.env.REACT_APP_QUICK_BOOK_V1 === "true";
const QuickBookLauncher = lazyWithStyles(() => import("./QuickBookLauncher"));

const QuickBookRouteEntry = ({ enabled = QUICK_BOOK_V1_ENABLED }) => {
  const { pathname } = useLocation();
  const placement = resolveQuickBookPlacement(pathname);
  if (!enabled || !placement) return null;

  return (
    <React.Suspense fallback={null}>
      <QuickBookLauncher key={pathname} homePlacement={placement === "home"} />
    </React.Suspense>
  );
};

QuickBookRouteEntry.propTypes = { enabled: PropTypes.bool };

export default QuickBookRouteEntry;
